<template>
  <div class="tw-relative tw-inline-block" ref="menuRoot">
    <!-- Button -->
    <button
      :id="`more-btn-${id}`"
      :type="type"
      @click="toggleMenu"
      :disabled="props.disabled || props.loading"
      :class="[
        'tw-h-[40px] tw-flex tw-items-center tw-border tw-rounded-[8px] tw-overflow-hidden tw-border-blue-dark-500',
        color === 'primary' &&
          'tw-bg-white tw-text-primary-500 tw-border-primary-500',
        disabled &&
          color === 'primary' &&
          '!tw-text-primary-300 !tw-border-primary-300',
        color === 'blue-dark' &&
          'tw-bg-white tw-text-blue-dark-500 tw-border-blue-dark-500',
        disabled &&
          color === 'blue-dark' &&
          '!tw-bg-gray-100 !tw-border-blue-dark-200',
        disabled && 'tw-opacity-50 tw-cursor-not-allowed',
        btn_clases,
      ]"
    >
      <!-- Right side (text) -->
      <span class="tw-px-4 tw-py-2 tw-flex-1 tw-text-sm tw-font-medium">
        {{ label }}
      </span>

      <!-- Left side (icon) -->
      <span
        :class="[
          'tw-px-3 tw-py-2 tw-border-r tw-flex tw-items-center',
          color === 'primary' && 'tw-border-primary-500',
          color === 'blue-dark' && 'tw-border-blue-dark-500',
        ]"
      >
        <loading-spinner v-if="loading" size="sm" :show="true" />
        <base-icon v-else icon="more" class="fs-21"></base-icon>
      </span>
    </button>
    <!-- Dropdown -->
    <transition
      enter-active-class="tw-transition tw-duration-300 tw-ease-out"
      enter-from-class="tw-opacity-0 tw-scale-95"
      enter-to-class="tw-opacity-100 tw-scale-100"
      leave-active-class="tw-transition tw-duration-200 tw-ease-in"
      leave-from-class="tw-opacity-100 tw-scale-100"
      leave-to-class="tw-opacity-0 tw-scale-95"
    >
      <div
        v-if="open"
        class="tw-absolute tw-inline-table tw-min-w-48 tw-bg-white tw-border tw-border-gray-500 tw-rounded-lg tw-shadow-lg tw-z-50 tw-overflow-hidden tw-bottom-[calc(100%+5px)] tw-left-0"
        :class="[
          // dropdownPosition === 'left' ? 'tw-bottom-0 tw-right-[calc(100%+5px)]' : 'tw-bottom-[calc(100%+5px)] tw-left-0'
        ]"
      >
        <ul class="options_list tw-text-sm tw-mb-0 tw-overflow-hidden">
          <slot name="options" />
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, defineExpose } from 'vue'
import BaseIcon from '@/components/base/BaseIcon.vue'
import LoadingSpinner from '@/components/loading/LoadingSpinner.vue'

const open = ref(false)
const menuRoot = ref(null)
const id = Math.random().toString(36).slice(2)
// const dropdownPosition = ref('')

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'outline',
    validator(value) {
      return ['outline', 'fill'].includes(value)
    },
  },
  color: {
    type: String,
    default: 'primary',
    validator(value) {
      return ['primary', 'blue-dark'].includes(value)
    },
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'button',
  },
})
const toggleMenu = () => {
  open.value = !open.value
}

const closeMenu = () => {
  open.value = false
}

// بستن منو وقتی بیرون کلیک می‌شود
const clickOutside = (e) => {
  if (menuRoot.value && !menuRoot.value.contains(e.target)) {
    closeMenu()
  }
}

onMounted(() => {
  document.addEventListener('click', clickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', clickOutside)
})

const btn_clases = computed(() => {
  let classes = ''
  if (props.variant === 'fill') {
    classes += `tw-bg-${props.color}-500 tw-text-white tw-border-${props.color}-500`
  } else {
    classes += `tw-bg-white tw-text-${props.color}-500 tw-border-${props.color}-500`
  }
  classes += props.class || ''
  return classes
})

defineExpose({
  closeMenu,
})

// onMounted(() => {
//   const btn = document.querySelector('#more-btn-' + id);
//   const rect = btn.getBoundingClientRect();
//
//   const width_options = 200
//   if(rect.left > width_options) {
//     dropdownPosition.value = 'left'
//   } else {
//     dropdownPosition.value = 'top'
//   }
// })

// const calcPosition = () => {
//   const btn = document.querySelector('#more-btn-' + id)
//   if (!btn) return
//
//   const rect = btn.getBoundingClientRect()
//   const dropdownWidth = 200
//
//   dropdownPosition.value =
//     rect.left >= dropdownWidth ? 'left' : 'top'
// }

// onMounted(calcPosition)
// window.addEventListener('resize', calcPosition)
</script>

<style>
.options_list li [class^='icon-'] {
  @apply tw-align-middle;
}
.options_list li {
  @apply hover:tw-bg-gray-100 tw-whitespace-nowrap;
}
</style>
